import React from 'react';

import PropTypes from 'prop-types';
import pt from 'date-fns/locale/pt';
import { format, parseISO } from 'date-fns';

import { Grid } from './styles';

export default function Fiscais({ dados }) {
  const data = dados.map(item => ({
    ...item,
    dateFormatted: item.data_protocolo
      ? format(parseISO(item.data_protocolo), "dd 'de' MMMM' de' yyyy", {
          locale: pt,
        })
      : null,
    dateVigencia: item.fim_vig
      ? format(parseISO(item.fim_vig), "dd 'de' MMMM' de' yyyy", {
          locale: pt,
        })
      : null,
  }));

  return (
    <Grid>
      {data.map(item => (
        <div key={item.id} className="content">
          <div className="tabelas">
            <div>
              <strong>Órgão Fimado: </strong> {item.orgaos}
            </div>
            <div>
              <strong>Nº Acordo: </strong> {item.n_acordo}
            </div>
            <div>
              <strong>Fim Vigência: </strong> {item.dateVigencia}
            </div>
            <div>
              <strong>Data limite protocolado pela Secran: </strong>{' '}
              {item.dateFormatted}
            </div>
          </div>
          <div className="tabelas">
            <div>
              <strong>Nº Protocolo: </strong> {item.n_proto}
            </div>
            <div>
              <strong>Observações: </strong> {item.obs}
            </div>
          </div>
        </div>
      ))}
    </Grid>
  );
}

Fiscais.propTypes = {
  dados: PropTypes.array, //eslint-disable-line
};

Fiscais.defaultProps = {
  dados: [],
};
